
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import MyStrategies from '@/components/account/MyStrategies';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { useAuthState } from '@/hooks/useAuthState';

const PersonalStrategiesDashboard = () => {
  const { user, isLoading } = useAuthState();
  const [selectedStrategy, setSelectedStrategy] = useState<string | null>(null);

  if (isLoading || !user) {
    return null;
  }

  return (
    <motion.section 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
      className="py-12 bg-white"
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-2xl font-bold text-corporate-primary-100">
            My Strategies
          </h2>
          <Link to="/marketplace">
            <Button variant="outline" size="sm">
              View All <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
        
        <MyStrategies
          strategies={[]} // Will be populated by the component itself
          onSelectStrategy={setSelectedStrategy}
          isLoading={false}
        />
      </div>
    </motion.section>
  );
};

export default PersonalStrategiesDashboard;
